import React, { useCallback } from 'react'
import { Button as MuiButton, CircularProgress } from '@material-ui/core'
import { buttonStyle } from './button.style'

export const Button = ({ loading, children, disabled, startIcon, ...props }) => {
	const handleClick = useCallback(() => {
		if (props.onTrackingEvent) {
			props.onTrackingEvent()
		}
	}, [props])

	return (
		<MuiButton
			disabled={loading || disabled}
			startIcon={loading ? <CircularProgress size={20} /> : startIcon}
			css={buttonStyle}
			onClick={handleClick}
			{...props}
		>
			{children}
		</MuiButton>
	)
}

Button.defaultProps = {
	fullWidth: true,
	color: 'primary',
	variant: 'contained',
	size: 'large',
}
